// import React from "react";
// import {
//   Box,
//   Typography,
//   Avatar,
//   Paper,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   Chip
// } from "@mui/material";
// import { motion } from "framer-motion";
// import dayjs from "dayjs";
// import { getData } from "../Webservice/Webservice";

// export default function RecentCustomers() {
//   // 🔹 Sample Data
//   const recentCustomers = [
//     {
//       _id: "690dba4aee896ee86afce8e6",
//       customerId: "CUS-0002",
//       name: "Ganesh",
//       gender: "male",
//       createdAt: "2025-11-07T09:22:18.068Z"
//     },
//     {
//       _id: "690db9e4ee896ee86afce8d4",
//       customerId: "CUS-0001",
//       name: null,
//       gender: null,
//       createdAt: "2025-11-07T09:20:36.561Z"
//     }
//   ];

//   return (
//     <Paper
//       component={motion.div}
//       elevation={3}
//       sx={{
//         borderRadius: 4,
//         p: 3,
//         background: "linear-gradient(135deg, #f9fafb, #ffffff)",
//         mt: 3
//       }}
//       initial={{ opacity: 0, y: 20 }}
//       animate={{ opacity: 1, y: 0 }}
//       transition={{ duration: 0.5 }}
//     >
//       {/* Header */}
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           mb: 3
//         }}
//       >
//         <Typography
//           variant="h5"
//           sx={{
//             fontWeight: 700,
//             textAlign: "center",
//             color: "text.primary",
//             fontFamily: "Mulish, sans-serif",
//             mt: 4
//           }}
//         >
//           Recent Customers
//         </Typography>
//         <Typography variant="body2" sx={{ color: "text.secondary" }}>
//           Showing last {recentCustomers.length} customers
//         </Typography>
//       </Box>

//       {/* Table */}
//       <Table>
//         <TableHead>
//           <TableRow sx={{ backgroundColor: "#f4f6f8" }}>
//             <TableCell sx={{ fontWeight: 600 }}>Customer ID</TableCell>
//             <TableCell sx={{ fontWeight: 600 }}>Name</TableCell>
//             <TableCell sx={{ fontWeight: 600 }}>Gender</TableCell>
//             <TableCell sx={{ fontWeight: 600 }}>Joined Date</TableCell>
//           </TableRow>
//         </TableHead>

//         <TableBody>
//           {recentCustomers.map(customer =>
//             <TableRow key={customer._id}>
//               <TableCell sx={{ fontWeight: 600, color: "#000000ff" }}>
//                 {customer.customerId}
//               </TableCell>

//               <TableCell>
//                 <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//                   {/* <Avatar
//                     sx={{
//                       bgcolor: "#e2d52aff",
//                       color: "#000000ff",
//                       fontSize: 16,
//                       fontWeight: 600
//                     }}
//                   >
//                     {customer.name
//                       ? customer.name.charAt(0).toUpperCase()
//                       : <FiUser size={18} />}
//                   </Avatar> */}
//                   <Typography sx={{ fontWeight: 500, color: "#111827" }}>
//                     {customer.name || "Unknown"}
//                   </Typography>
//                 </Box>
//               </TableCell>

//               <TableCell>
//                 {customer.gender
//                   ? <Chip
//                       label={customer.gender}
//                       color={
//                         customer.gender === "male" ? "primary" : "secondary"
//                       }
//                       size="small"
//                       sx={{ textTransform: "capitalize" }}
//                     />
//                   : <Chip label="N/A" color="default" size="small" />}
//               </TableCell>

//               <TableCell sx={{ color: "text.secondary" }}>
//                 {dayjs(customer.createdAt).format("DD MMM, YYYY")}
//               </TableCell>
//             </TableRow>
//           )}
//         </TableBody>
//       </Table>
//     </Paper>
//   );
// }

import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Avatar,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  CircularProgress,
  Alert
} from "@mui/material";
import { motion } from "framer-motion";
import dayjs from "dayjs";
import { FiUser } from "react-icons/fi";
import { getData } from "../Webservice/Webservice";

export default function RecentCustomers() {
  const [recentCustomersData, setRecentCustomersData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRecentCustomers = async () => {
      try {
        setLoading(true);
        setError(null);
        const tokenValue = sessionStorage.getItem("token");
        const token = tokenValue ? `Bearer ${tokenValue}` : "";
        const data = await getData("dashboard/recent-customers", null, token);

        if (data && data.success && data.recentCustomers) {
          setRecentCustomersData(data);
        } else {
          throw new Error("Invalid recent customers response format");
        }
      } catch (err) {
        setError(err.message || "Failed to load recent customers");
      } finally {
        setLoading(false);
      }
    };

    fetchRecentCustomers();
  }, []);

  // Show loading state
  if (loading) {
    return (
      <Paper
        component={motion.div}
        elevation={3}
        sx={{
          borderRadius: 4,
          p: 3,
          background: "linear-gradient(135deg, #f9fafb, #ffffff)",
          mt: 3,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: 400
        }}
      >
        <CircularProgress />
      </Paper>
    );
  }

  // Show error state
  if (error) {
    return (
      <Paper
        component={motion.div}
        elevation={3}
        sx={{
          borderRadius: 4,
          p: 3,
          background: "linear-gradient(135deg, #f9fafb, #ffffff)",
          mt: 3
        }}
      >
        <Alert severity="error">
          {error}
        </Alert>
      </Paper>
    );
  }

  // Show data when available
  if (!recentCustomersData) {
    return null;
  }

  const { recentCustomers, totalCount } = recentCustomersData;

  return (
    <Paper
      component={motion.div}
      elevation={3}
      sx={{
        borderRadius: 4,
        p: 3,
        background: "linear-gradient(135deg, #f9fafb, #ffffff)",
        mt: 3
      }}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            textAlign: "center",
            color: "text.primary",
            fontFamily: "Mulish, sans-serif",
            mt: 4
          }}
        >
          Recent Customers
        </Typography>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          Showing last {recentCustomers.length} customers
        </Typography>
      </Box>

      {/* Table */}
      <Table>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#f4f6f8" }}>
            <TableCell sx={{ fontWeight: 600 }}>Customer ID</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Name</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Gender</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Joined Date</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {recentCustomers.map(customer =>
            <TableRow key={customer._id}>
              <TableCell sx={{ fontWeight: 600, color: "#000000ff" }}>
                {customer.customerId}
              </TableCell>

              <TableCell>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                  <Avatar
                    sx={{
                      bgcolor: "#e2d52aff",
                      color: "#000000ff",
                      fontSize: 16,
                      fontWeight: 600,
                      width: 32,
                      height: 32
                    }}
                  >
                    {customer.name
                      ? customer.name.charAt(0).toUpperCase()
                      : <FiUser size={18} />}
                  </Avatar>
                  <Typography sx={{ fontWeight: 500, color: "#111827" }}>
                    {customer.name || "Unknown"}
                  </Typography>
                </Box>
              </TableCell>

              <TableCell>
                {customer.gender
                  ? <Chip
                      label={customer.gender}
                      color={
                        customer.gender === "male" ? "primary" : "secondary"
                      }
                      size="small"
                      sx={{ textTransform: "capitalize" }}
                    />
                  : <Chip label="N/A" color="default" size="small" />}
              </TableCell>

              <TableCell sx={{ color: "text.secondary" }}>
                {dayjs(customer.createdAt).format("DD MMM, YYYY")}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Paper>
  );
}
